/* The row itself is <SettingsRow>; only the code's own treatment lives here,
   and spacing is the caller's. */
.code {
	font-weight: 700;
	font-size: 1.1rem;
	letter-spacing: 0.15em;
}
